/**
 * Admin Orders Tab - View shop orders
 */
import { Package } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { useAdmin } from "./AdminContext";

const AdminOrdersTab = () => {
  const { orders } = useAdmin();

  const getStatusColor = (status) => {
    const colors = { 
      pending: "bg-amber-100 text-amber-700", 
      processing: "bg-blue-100 text-blue-700",
      shipped: "bg-purple-100 text-purple-700",
      delivered: "bg-green-100 text-green-700", 
      cancelled: "bg-red-100 text-red-700" 
    };
    return colors[status] || "bg-stone-100 text-stone-700";
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle><Package className="w-5 h-5 inline mr-2" />Orders</CardTitle>
        <CardDescription>View and manage shop orders</CardDescription>
      </CardHeader>
      <CardContent>
        {orders.length === 0 ? (
          <p className="text-center text-stone-500 py-8">No orders yet</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Order ID</TableHead>
                <TableHead>Customer</TableHead>
                <TableHead>Items</TableHead>
                <TableHead>Total</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Date</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {orders.map(order => (
                <TableRow key={order.order_id}>
                  <TableCell className="font-mono text-sm">{order.order_id?.slice(-8)}</TableCell>
                  <TableCell>
                    <p className="font-medium">{order.customer_name || order.shipping_address?.name || "-"}</p>
                    <p className="text-xs text-stone-500">{order.customer_email || "-"}</p>
                  </TableCell>
                  <TableCell>
                    {order.items?.length || 0} item(s)
                  </TableCell>
                  <TableCell className="font-bold">£{order.total?.toFixed(2) || "0.00"}</TableCell>
                  <TableCell>
                    <Badge className={getStatusColor(order.status)}>{order.status || "pending"}</Badge>
                  </TableCell>
                  <TableCell className="text-sm">{new Date(order.created_at).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};

export default AdminOrdersTab;
